import { connect } from 'react-redux'

import { selectPosition } from '../../actions/positionActionCreators'

const mapStateToProps = ({ browser }, ownProps) => ({
  isSmallScreen: browser.lessThan.medium,
  currentView: ownProps.currentView,
})

const mapDispatchToProps = dispatch => ({
  onNavBackClick: (e) => {
    e.preventDefault()
    dispatch(selectPosition(null)) // Resets selection
  }
})

export default connect(mapStateToProps, mapDispatchToProps)


// WEBPACK FOOTER //
// ./src/components/MainDetail/mainDetailContainer.js